<template>
  <div class="burger" :class="{ 'active' : value }" @click.prevent="toggle">
    <slot>
      <button type="button" class="burger-button" title="Menu">
        <span class="burger-bar burger-bar--1" />
        <span class="burger-bar burger-bar--2" />
        <span class="burger-bar burger-bar--3" />
      </button>
    </slot>
  </div>
</template>

<script>
export default {
  name: "Burger",
  props: ['value'],
  data: function() {
    return {
      isBurgerActive: this.value
    }
  },
  methods: {
    toggle() {
      this.isBurgerActive = !this.isBurgerActive;
      this.$emit("input", this.isBurgerActive);
    }
  },
  watch: {
    value: function (value) {
      this.isBurgerActive = value;
    }
  }
}
</script>

<style scoped lang="scss">
button {
  cursor: pointer;
  &:focus {
    outline: 0;
  }
}

.burger-button {
  position: relative;
  height: 30px;
  width: 32px;
  display: block;
  z-index: 999;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  pointer-events: all;
  transition: transform .6s cubic-bezier(.165, .84, .44, 1);
}

.burger-bar {
  background-color: $white;
  position: absolute;
  top: 50%;
  right: 6px;
  left: 6px;
  height: 2px;
  width: auto;
  margin-top: -1px;
  transition: transform .6s cubic-bezier(.165, .84, .44, 1),
              opacity .3s cubic-bezier(.165, .84, .44, 1),
              background-color .6s cubic-bezier(.165, .84, .44, 1);
  &--1 {
    -webkit-transform: translateY(-6px);
    transform: translateY(-6px);
  }
  &--2 {
    transform-origin: 100% 50%;
    transform: scaleX(1);
  }
  &--3 {
    transform: translateY(6px);
  }
}

.burger-button:hover .burger-bar--2 {
  transform: scaleX(1);
}

.no-touchevents .burger-bar--2:hover {
  transform: scaleX(1);
}

.burger {
  &.active {
    .burger-button {
      transform: rotate(-180deg);
    }
    .burger-bar {
      background-color: #fff;
      &--1 {
        transform: rotate(45deg)
      }
      &--2 {
        opacity: 0;
      }
      &--3 {
        transform: rotate(-45deg)
      }
    }
  }
}
</style>
